/**
 * About section. Short narrative on the left, founders photo on the right.
 * Replaces the quality-approach card with a personal image — the partnership
 * story in the copy is reinforced by showing the people behind it.
 */
import { SectionLabel } from "../layout/SectionLabel";
import foundersWebp from "../../assets/founders.webp";
import foundersJpg from "../../assets/founders.jpg";

export function About() {
  return (
    <section
      id="about"
      className="section-anchor mx-auto max-w-7xl px-4 pt-8 pb-32 sm:px-6 sm:pt-12 sm:pb-40"
    >
      <SectionLabel>About</SectionLabel>

      <div className="mt-4 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-7">
          <h2 className="max-w-2xl text-3xl font-bold tracking-tight text-white sm:text-4xl">
            A small shop, built around quick-turn precision work.
          </h2>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-slate-300">
           <p>
		      Our thesis at <span className="font-bold">AnyAngle</span> is simple: modern CNC, careful setup, and a tight workflow can deliver aerospace-grade tolerances on quantities of one to a hundred without the lead time of a tier-one supplier.
              We use the same metrology and tool-setting equipment the big
              shops do; we just run fewer jobs at a time so each one gets
              attention.
            </p>
            <p>
              We work mostly with defense, aerospace, and hardware product
              teams. Send us a STEP file and a print, and we'll tell you within
              a day what it'll cost and when you can have it.
            </p>
          </div>
        </div>

        <aside className="lg:col-span-5">
          <div className="relative overflow-hidden rounded-xl border border-bg-border">
            <picture>
              <source srcSet={foundersWebp} type="image/webp" />
              <img
                src={foundersJpg}
                alt="The founders of AnyAngle"
                width={1000}
                height={955}
                className="block h-auto w-full object-cover"
                loading="lazy"
              />
            </picture>
            <div
              aria-hidden="true"
              className="pointer-events-none absolute inset-0 bg-brand-500/10 mix-blend-color"
            />
          </div>
        </aside>
      </div>
    </section>
  );
}
